import axios from "axios";
import { newAbortSignal } from "../../../utils";
import { SessionStore } from "../../../types/store";
import { FeatureCollection } from "../../../types/model/captureLocation";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/locations`;

export interface CadastralParcelMapFilters {
  entityId?: number;
  managementUnitId?: number;
  captureId?: number;
}

export const getCadastralParcelMapLayer = async (
  filters?: CadastralParcelMapFilters
): Promise<FeatureCollection> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const res = await axios.get<FeatureCollection>(`${BASE_URL}/cadastral-parcel-map`, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    params: filters,
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
